import React, { Component } from 'react'
import { GetData } from '../../../api/service';
import AckReceipt from './AckReceipt';
import { CircularProgress, Typography } from '@material-ui/core';

export default class AckLanding extends Component {

    state = {
        data: {},
        isLoaded: false
    }

    componentDidMount() {
        this.fetchMyAck();
    }

    fetchMyAck = () => {
        GetData(`/${this.props.user.apikey}/fetchmyack`)
            .then((resp) => {
                
                if (resp.status == true) {
                    this.setState({
                        data: resp.status_text,
                        isLoaded: true
                    })
                } else {
                    this.props.history.push(`/admission`)
                }

            }).catch(() => {
                this.props.history.push(`/admission`)
            })
    }
    render() {
        return (
            <div>

                {!this.state.isLoaded && <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '200px'
                    }}
                >
                    <CircularProgress />
                    <br />
                    <Typography variant="caption">
                        Fetching Receipt . . . Please wait
                    </Typography>
                </div>}

                {this.state.isLoaded && <AckReceipt
                    data={this.state.data}
                />}
            </div>
        )
    }
}
